<template>
    <v-dialog v-model="modalAbierto" width="500">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <slot />
            </div>
        </template>

        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                {{ $t("componentes.modal-busqueda.titulo") }}
            </v-card-title>

            <BuscadorIndicadores @busqueda="modalAbierto = false"></BuscadorIndicadores>
        </v-card>
    </v-dialog>
</template>

<script>
import BuscadorIndicadores from "./BuscadorIndicadores.vue";

export default {
    data() {
        return {
            modalAbierto: false,
        };
    },
    components: { BuscadorIndicadores },
};
</script>
